export default __webpack_public_path__ + "static/remy-bitmoji-ff438f61368d9ff9e797ba2c2aca3ad1.png";